import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CryptoJS from 'crypto-js'; // Importar la biblioteca crypto-js
import BASE_URL from '../config/config';
import { FiUser, FiLock, FiArrowLeft, FiEye, FiEyeOff } from 'react-icons/fi';
import { consumirMotivoCaducidad, EVENTO_SESION_CADUCADA } from '../auth/sesion';
import SelectorIdioma from '../components/ui/SelectorIdioma';

const IniciarSesion = () => {
  const { t } = useTranslation();
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  // La marca la deja el cierre automático de sesión y se consume una sola vez.
  const [sesionCaducada, setSesionCaducada] = useState(consumirMotivoCaducidad);

  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.successMessage;

  // Si la sesión caduca estando ya en esta pantalla, no hay recarga: avisamos por evento.
  useEffect(() => {
    const alCaducar = () => setSesionCaducada(true);
    window.addEventListener(EVENTO_SESION_CADUCADA, alCaducar);
    return () => window.removeEventListener(EVENTO_SESION_CADUCADA, alCaducar);
  }, []);

  const handleUsuarioChange = (event) => {
    // Mantener el valor tal cual (no convertir a minúsculas para emails)
    setUsuario(event.target.value);
  };

  const handleContrasenaChange = (event) => {
    setContrasena(event.target.value);
  };

  const handleSubmit = async () => {
    setSesionCaducada(false);
    try {
      // Encriptar la contraseña en MD5 antes de enviarla
      const contrasenaEncriptada = CryptoJS.MD5(contrasena).toString();

      const response = await axios.post(`${BASE_URL}/login`, { 
        usuario: usuario.toLowerCase(), // Normalizar a minúsculas para la búsqueda
        contrasena: contrasenaEncriptada
      });
      
      if (response.status === 200) {
        // Iniciar sesión exitosa, redirigir al usuario
        localStorage.setItem("AuthToken", response.data.jwt_token);
        window.location.reload();
      } else {
        // Inicio de sesión fallido, mostrar mensaje de error
        setError(response.data.message);
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setError(t('auth.errorGenerico'));
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <main className='inicia-sesion'>
      <div className="bg-intro-blob bg-intro-blob-1"></div>
      <div className="inicio-idioma"><SelectorIdioma /></div>
      <Link to="/" className="volver-inicio"><FiArrowLeft /> {t('comun.volverInicio')}</Link>
      <div className='formulario-inicio'>
        <div className="logo-form-inicio">
          <img src="/images/logoadhoc.svg" alt={t('comun.marcaLogo')} />
          <p className="p-soporte">v3.0</p>
        </div>
        <h1>{t('auth.titulo')}</h1>
        <p>{t('auth.subtitulo')}</p>
        <div className='campos-inicio'>
          <div className="campo-inicio">
            <label htmlFor="user">{t('auth.usuarioOEmail')}</label>
            <div className="campo-inicio-input">
              <FiUser className="campo-inicio-icon" />
              <input autoComplete="off" type="text" id="user" value={usuario} onChange={handleUsuarioChange} placeholder={t('auth.placeholderUsuario')} />
            </div>
          </div>
          <div className="campo-inicio">
            <label htmlFor='password'>{t('comun.contrasena')}</label>
            <div className="campo-inicio-input">
              <FiLock className="campo-inicio-icon" />
              <input autoComplete="off" type={mostrarContrasena ? 'text' : 'password'} name="password" value={contrasena} onChange={handleContrasenaChange} id="password" placeholder={t('auth.placeholderContrasena')} onKeyDown={handleKeyDown} />
              <button type="button" className="campo-inicio-toggle" onClick={() => setMostrarContrasena(prev => !prev)} aria-label={mostrarContrasena ? t('comun.ocultarContrasena') : t('comun.mostrarContrasena')}>
                {mostrarContrasena ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>
          <p className='lost-password'>{t('auth.olvidasteContrasena')} <Link to={'/recuperar-contrasena'}>{t('auth.solicitaNueva')}</Link></p>
          {sesionCaducada && (
            <p className="aviso-sesion" role="alert">
              {t('auth.sesionCaducada')}
            </p>
          )}
          {successMessage && <p className="success">{successMessage}</p>}
          {error && <p className="error">{error}</p>}
          <button type="button" onClick={handleSubmit}>{t('auth.acceder')}</button>
        </div>
      </div>
    </main>
  );
};

export default IniciarSesion;
